import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { InputGroup, Button, FormControl, Col } from "react-bootstrap";
import _ from "lodash";
import ApiAmusementPackage from "../../../core/api/api.amusementPackage";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { AddEditePackageNameModal } from "./AddEditePackageNameModal";
import { PackageOrderModal } from "./PackageOrderModal";
import { tools } from "../../../core/utils/tools";
import SwapVert from "@mui/icons-material/SwapVert";
import GlobalFormControl from "../_Components/GlobalFormControl";

const AmusementPackage = () => {
  const navigate = useNavigate();

  const [listData, setListData] = useState({});
  const [createPackageModal, setCreatePackageModal] = useState(false);
  const [packageOrderModal, setPackageOrderModal] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

        const data = await ApiAmusementPackage.getAllAmusementPackages({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });

        setListData(data);
        setValue("totalCount", data.totalCount);

        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiAmusementPackage.getAllAmusementPackages(data);
    const queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    navigate(`/amusementPackage?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom `}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت پکیج تفریحات</span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setCreatePackageModal(true);
                setSelectedPackageId(0);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد پکیج تفریحات
            </Button>
            <Button
              variant="success"
              onClick={() => {
                setPackageOrderModal(true);
              }}
              className="me-2"
            >
              <SwapVert className="mr-1" />
              مرتب سازی پکیج تفریحات
            </Button>
          </div>
        </div>

        <div className="card-body pt-3 pb-0">
          <div className="border-top pt-3">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                {/* search box */}
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid
                    data={listData}
                    setCreatePackageModal={setCreatePackageModal}
                    setSelectedPackageId={setSelectedPackageId}
                  />
                </Col>
              </form>
            </FormProvider>
            {createPackageModal && (
              <AddEditePackageNameModal
                createPackageModal={createPackageModal}
                setCreatePackageModal={setCreatePackageModal}
                selectedPackageId={selectedPackageId}
              />
            )}
            {packageOrderModal && (
              <PackageOrderModal
                packageOrderModal={packageOrderModal}
                setPackageOrderModal={setPackageOrderModal}
                packages={listData}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmusementPackage;
